import { compose, hoistStatics, lifecycle, withHandlers, withState } from 'recompose';
import { translate } from 'react-i18next';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import ExtButton from './ExtButton';
import mh from '../../../../../helpers/messenger.helper';
import ChannelsService from '../../../../../services/channels.service';

const loadMore = props => async () => {
  const {
    users,
    hasMore,
    criteria,
    setUsers,
    isLoading,
    setHasMore,
    setCriteria,
    setIsLoading,
    setUsersCount,
  } = props;
  const loadDataMore = isLoading ? false : hasMore;
  if (loadDataMore) {
    setIsLoading(true);
    const nextPage = criteria.page + 1;
    //TODO: ABOVE
    const { data, count } = await ChannelsService.getUsersDirect({ ...criteria, page: nextPage });
    let newHasMore = false;
    if (users.length + data.length < count) {
      newHasMore = true;
    }
    setUsers([...users, ...data]);
    setHasMore(newHasMore);
    setIsLoading(false);
    setUsersCount(count);
    setCriteria({ ...criteria, page: nextPage });
  }
};

const userSearchCallback = props => async (value) => {
  const { criteria } = props;
  await loadMore({ ...props, criteria: { ...criteria, name: value, page: -1 }, users: [], hasMore: true })();
};

const defaultCriteria = {
  limit: 10,
  page: -1,
};

const startChat = props => async (e, newUser) => {
  e.preventDefault();
  const { channel } = await ChannelsService.createNewDirect(newUser.id)
  if (channel) {
    mh.startChat(props)(null, channel.id);
  }
};

const mapStateToProps = state => ({
  user: state.user.user.id,
});


const enhance = compose(
  connect(mapStateToProps, null),
  translate('portal'),
  withState('isLoading', 'setIsLoading', false),
  withState('users', 'setUsers', []),
  withState('usersCount', 'setUsersCount', 0),
  withState('criteria', 'setCriteria', defaultCriteria),
  withState('hasMore', 'setHasMore', true),
  lifecycle({
    async componentDidMount() {
      await loadMore(this.props)();
    },
  }),
  withHandlers({
    loadMore,
    userSearchCallback,
    startChat,
  }),
);


export default withRouter(hoistStatics(enhance)(ExtButton));



// WEBPACK FOOTER //
// ./src/views/modules/messages/startConversation/extButton/index.js